declare global {
  interface Window {
    /** Set by the plugin's init script before any page script runs. */
    __ODIN_PLATFORM__?: string;
  }
}

/** Native OS comes from the plugin, never from a WebView user agent. */
export const isTauri = typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
export const platform: string = isTauri ? (window.__ODIN_PLATFORM__ ?? 'unknown') : 'browser';
export const isAndroid = platform === 'android';
export const isApple = platform === 'macos' || platform === 'ios';
export const isLinux = platform === 'linux';
export const isWindows = platform === 'windows';
export const isMobile = platform === 'ios' || isAndroid;
